import { JOB_DESCRIPTION, JOB_VIDEO_LINKS } from '../constants/MarketplaceConstants';
import zepto_testimonial from '../assets/zepto_testimonial.svg';
import swiggy_testimonial from '../assets/swiggy_testimonial.svg';
import dunzo_testimonial from '../assets/dunzo_testimonial.svg';
import uber_testimonial from '../assets/uber_testimonial.svg';
import rapido_testimonial from '../assets/rapido_testimonial.svg';
import zomato_testimonial from '../assets/zomato_testimonial.svg';
import flipkart_testimonial from '../assets/flipkart_testimonial.svg';
import delhivery_testimonial from '../assets/delhivery_testimonial.svg';
import bigbasket_testimonial from '../assets/bigbasket.svg';
// todo - default image to be changed
import default_testimonial from '../assets/jd_testimonial.svg';

export const getJobDescription = (client) => {
    switch (client?.toLowerCase()) {
      case 'rapido':
        return JOB_DESCRIPTION.RAPIDO;
        break;
      case 'rapido_3pl':
        return JOB_DESCRIPTION.RAPIDO_3PL;
        break;
      case 'uber':
        return JOB_DESCRIPTION.UBER;
        break;
      case 'uber_3pl':
        return JOB_DESCRIPTION.UBER;
        break;
      case 'zomato':
        return JOB_DESCRIPTION.ZOMATO;
        break;
      case 'zomato_3pl':
        return JOB_DESCRIPTION.ZOMATO_3PL;
        break;
      case 'zepto':
        return JOB_DESCRIPTION.ZEPTO;
        break;
      case 'zepto_3pl':
        return JOB_DESCRIPTION.ZEPTO_3PL;
        break;
      case 'delhivery_3pl':
        return JOB_DESCRIPTION.DELHIVERY_3PL;
        break;
      case 'flipkart':
        return JOB_DESCRIPTION.FLIPKART;
      case 'swiggy':
        return JOB_DESCRIPTION.SWIGGY;
        break;
      case 'dunzo':
        return JOB_DESCRIPTION.DUNZO;
        break;
      default:
        return {};
        break;
    }
  };

export const getClientIcon = (clientName) => {
  switch (clientName?.toLowerCase()) {
    case 'rapido':
      return "/images/client-logos/rapido.png";
      break;
    case 'rapido_3pl':
      return "/images/client-logos/rapido.png";
      break;
    case 'uber':
      return "/images/client-logos/uber.png";
      break;
    case 'uber_3pl':
      return "/images/client-logos/uber.png";
      break;
    case 'zomato':
      return "/images/client-logos/zomato.png";
      break;
    case 'zomato_3pl':
      return "/images/client-logos/zomato.png";
      break;
    case 'zepto':
      return "/images/client-logos/zepto.png";
      break;
    case 'zepto_3pl':
      return "/images/client-logos/zepto.png";
      break;
    case 'delhivery':
      return "/images/client-logos/delhivery.png";
      break;
    case 'delhivery_3pl':
      return "/images/client-logos/delhivery.png";
      break;
    case 'swiggy':
      return "/images/client-logos/swiggy.png";
      break;
    case 'dunzo':
      return "/images/client-logos/dunzo.png";
    case 'flipkart':
      return "/images/client-logos/flipkart.png";
      break;
    case 'bigbasket_3pl':
      return "/images/client-logos/bigbasket.png";
      break;
    default:
      return "";
      break;
  }
};

export const getClientVideoUrl = (client) => {
  switch (client?.toLowerCase()) {
    case 'rapido':
      return JOB_VIDEO_LINKS.RAPIDO;
      break;
    case 'rapido_3pl':
      return JOB_VIDEO_LINKS.RAPIDO;
      break;
    case 'uber':
      return JOB_VIDEO_LINKS.UBER;
      break;
    case 'uber_3pl':
      return JOB_VIDEO_LINKS.UBER;
      break;
    case 'zomato':
      return JOB_VIDEO_LINKS.ZOMATO;
      break;
    case 'zomato_3pl':
      return JOB_VIDEO_LINKS.ZOMATO;
      break;
    case 'zepto':
      return JOB_VIDEO_LINKS.ZEPTO;
      break;
    case 'zepto_3pl':
      return JOB_VIDEO_LINKS.ZEPTO;
      break;
    case 'delhivery':
      return JOB_VIDEO_LINKS.DELHIVERY;
      break;
    case 'delhivery_3pl':
      return JOB_VIDEO_LINKS.DELHIVERY;
      break;
    case 'flipkart':
    return JOB_VIDEO_LINKS.FLIPKART;
    break;
    default:
      return '';
      break;
  }
};

export const getCompanyTestimonial = (client) => {
  let clientTestimonial = null;
  switch (client.toLowerCase()) {
    case 'zepto':
      clientTestimonial = zepto_testimonial;
      break;
    case 'zepto_3pl':
      clientTestimonial = zepto_testimonial;
      break;
    case 'swiggy':
      clientTestimonial = swiggy_testimonial;
      break;
    case 'dunzo':
      clientTestimonial = dunzo_testimonial;
      break;
    case 'dunzo_3pl':
      clientTestimonial = dunzo_testimonial;
      break;
    case 'uber':
      clientTestimonial = uber_testimonial;
      break;
    case 'uber_3pl':
      clientTestimonial = uber_testimonial;
      break;
    case 'rapido':
      clientTestimonial = rapido_testimonial;
      break;
    case 'rapido_3pl':
      clientTestimonial = rapido_testimonial;
      break;
    case 'zomato':
      clientTestimonial = zomato_testimonial;
      break;
    case 'flipkart':
      clientTestimonial = flipkart_testimonial;
      break;
    case 'delhivery':
      clientTestimonial = delhivery_testimonial;
      break;
    case 'delhivery_3pl':
      clientTestimonial = delhivery_testimonial;
      break;
    case 'bigbasket_3pl':
      clientTestimonial = bigbasket_testimonial;
      break;
    default:
      clientTestimonial = default_testimonial;
  }
  return clientTestimonial;
}

export const numberWithCommas= (x) => {
  return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
}

export const formatPlaystoreNumbers = (val) => {
  const reviews = parseInt(val);

  if (val > 10000000) {
    return val/10000000;
  } else if (val > 100000) {
    return val/100000;
  } else if (val > 1000) {
    return val/1000;
  } else {
    return val;
  }
};

export const playstoreNumberSuffix = (val) => {
  if (val > 10000000) {
    return 'Cr';
  } else if (val > 100000) {
    return 'L';
  } else if (val > 1000) {
    return 'k';
  } else {
    return val;
  }
};
